import React from "react";
import { useSelector } from "react-redux";

import "./App.css";

import { Routes, Route, Link } from "react-router-dom";

import ActivityDefault from "./components/activity/ActivityDefault";
import MasterTemplate from "./components/master/MasterTemplate";
import WorkorderManagementDefault from "./components/workorderManagement/WorkorderManagementDefault";
import WorkorderManagementEdit from "./components/workorderManagement/WorkorderManagementEdit";
import LabelsDefault from "./components/labels/LabelsDefault";
import LabelsPrint from "./components/labels/LabelsPrint";
import ConsumptionDefault from "./components/consumption/ConsumptionDefault";
import PalstatDefault from "./components/palstat/PalstatDefault";
import UserDefault from "./components/user/UserDefault";
import UserPassword from "./components/user/UserPassword";
import AdminDefault from "./components/admin/AdminDefault";
import AdminUserWorkcentreRole from "./components/admin/UsersAdmin";
import AdminRoleFeature from "./components/admin/AdminRoleFeature";
import AdminPrinterLine from "./components/admin/AdminPrinters";
import CrewDefault from "./components/crew/CrewDefault";
import ConsumptionDetails from "./components/consumption/ConsumptionDetails";
import LoginTemplate from "./components/master/LoginTemplate";
import TestPageDefault from "./components/TestPage/TestPageDefault";
import SqlDeploy from "./components/admin/SqlDeploy";
import PalstatEdit from "./components/palstat/PalstatEdit";
import { IRootState } from "./types/redux/IRootStore";
import LabelsScheduling from "./components/labels/LabelsScheduling";
import { ActivityType } from "./types/activityType";
import WorkorderManagementMainPane from "./components/workorderManagement/WorkorderEdit/WorkorderManagementMainPane";
import WorkorderManagementMaterialPane from "./components/workorderManagement/WorkorderEdit/WorkorderManagementMaterialPane";
import WorkorderManagementOperationsPane from "./components/workorderManagement/WorkorderEdit/WorkorderManagementOperationsPane";
import WorkorderManagementBatchPane from "./components/workorderManagement/WorkorderEdit/WorkorderManagementBatchPane";
import WorkorderManagementBomPane from "./components/workorderManagement/WorkorderEdit/WorkorderManagementBomPane";
import WorkorderManagementTestPrintPane from "./components/workorderManagement/WorkorderEdit/WorkorderManagementTestPrintPane";
import WorkorderManagementBobPane from "./components/workorderManagement/WorkorderEdit/WorkorderManagementBobPane";
import WorkorderManagementLabelsPane from "./components/workorderManagement/WorkorderEdit/WorkorderManagementLabelsPane";
import MerckDefault from "./components/merck/MerckDefault";
import { useAppDispatch } from "./redux/hooks";
import { setGlobalDispatch, setGlobalGetState } from "./aplUtils/aplGlobals";
import { store } from "./redux/store";
import { getAplTokens } from "./aplUtils/cookiesWrapper";
import { dropUserConfig, loadUserConfigRedux } from "./redux/slices/auth.feature";
import { aplSettingsFromState } from "./redux/helpers/aplSettingsHelper";

function App() {
    const reduxState = useSelector((state: IRootState) => state);
    const authRedux = reduxState.auth;
    const aplSettings = aplSettingsFromState(reduxState);
    let dispatch = useAppDispatch();
    let getState = store.getState;

    setGlobalDispatch(dispatch);
    setGlobalGetState(getState as any);

    React.useEffect(() => {
        let tokens = getAplTokens();
        if (!authRedux.token && tokens.token) {
            dispatch(loadUserConfigRedux() as any);
        }
    }, [authRedux.token, dispatch]);

    if (!authRedux.token) {
        return (
            <React.Fragment>
                <LoginTemplate />
            </React.Fragment>
        );
    } else if (aplSettings.site == null || aplSettings.permissions.length === 0) {
        return (
            <React.Fragment>
                <div className="d-flex justify-content-center align-items-center vh-100">
                    User does not have permissions to any site. &nbsp;{" "}
                    <Link to={""} onClick={() => {
                        let tokens = getAplTokens();
                        dispatch(dropUserConfig(tokens.refreshToken) as any);
                    }}>
                        Back to login
                    </Link>
                </div>
            </React.Fragment>
        );
    } else {
        return (
            <React.Fragment>
                <Routes>
                    <Route path={"/login"} element={<LoginTemplate />} />
                    <Route
                        path={"/Account/Login"}
                        element={
                            <MasterTemplate>
                                <ActivityDefault />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/"}
                        element={
                            <MasterTemplate>
                                <ActivityDefault />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/activity"}
                        element={
                            <MasterTemplate>
                                <ActivityDefault></ActivityDefault>
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/workordermanagement"}
                        element={
                            <MasterTemplate>
                                <WorkorderManagementDefault activityType={ActivityType.Unspecified} />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/assigncons/:lineId"}
                        element={
                            <MasterTemplate>
                                <WorkorderManagementDefault activityType={ActivityType.Consumption} />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/assigncons"}
                        element={
                            <MasterTemplate>
                                <ConsumptionDefault />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/assignlabl/:lineId"}
                        element={
                            <MasterTemplate>
                                <WorkorderManagementDefault activityType={ActivityType.Labelling} />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/workordermanagement/:workorderId"}
                        element={
                            <MasterTemplate>
                                <WorkorderManagementEdit>
                                    <WorkorderManagementMainPane />
                                </WorkorderManagementEdit>{" "}
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/workordermanagement/:workorderId/labels"}
                        element={
                            <MasterTemplate>
                                <WorkorderManagementEdit>
                                    <WorkorderManagementLabelsPane />
                                </WorkorderManagementEdit>{" "}
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/workordermanagement/:workorderId/material"}
                        element={
                            <MasterTemplate>
                                <WorkorderManagementEdit>
                                    <WorkorderManagementMaterialPane />
                                </WorkorderManagementEdit>{" "}
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/workordermanagement/:workorderId/operations"}
                        element={
                            <MasterTemplate>
                                <WorkorderManagementEdit>
                                    <WorkorderManagementOperationsPane />
                                </WorkorderManagementEdit>{" "}
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/workordermanagement/:workorderId/bom"}
                        element={
                            <MasterTemplate>
                                <WorkorderManagementEdit>
                                    <WorkorderManagementBomPane />
                                </WorkorderManagementEdit>{" "}
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/workordermanagement/:workorderId/batch"}
                        element={
                            <MasterTemplate>
                                <WorkorderManagementEdit>
                                    <WorkorderManagementBatchPane />
                                </WorkorderManagementEdit>{" "}
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/workordermanagement/:workorderId/bob"}
                        element={
                            <MasterTemplate>
                                <WorkorderManagementEdit>
                                    <WorkorderManagementBobPane />
                                </WorkorderManagementEdit>{" "}
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/workordermanagement/:workorderId/test"}
                        element={
                            <MasterTemplate>
                                <WorkorderManagementEdit>
                                    <WorkorderManagementTestPrintPane />
                                </WorkorderManagementEdit>{" "}
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/assignlabl"}
                        element={
                            <MasterTemplate>
                                <LabelsDefault />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/consumption"}
                        element={
                            <MasterTemplate>
                                <ConsumptionDefault />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/consumption/:lineId"}
                        element={
                            <MasterTemplate>
                                <ConsumptionDetails />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/consumption/:lineId/:operationId"}
                        element={
                            <MasterTemplate>
                                <ConsumptionDetails />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/labels"}
                        element={
                            <MasterTemplate>
                                <LabelsDefault />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/labels/:lineId"}
                        element={
                            <MasterTemplate>
                                <LabelsPrint />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/labels/:lineId/:operationId"}
                        element={
                            <MasterTemplate>
                                <LabelsPrint />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/labels/schedule/:lineId"}
                        element={
                            <MasterTemplate>
                                <LabelsScheduling />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/palstat"}
                        element={
                            <MasterTemplate>
                                <PalstatDefault />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/palstat/:siteId"}
                        element={
                            <MasterTemplate>
                                <PalstatEdit />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/palstat/edit/:siteId/:sscc"}
                        element={
                            <MasterTemplate>
                                <PalstatEdit />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/user"}
                        element={
                            <MasterTemplate>
                                <UserDefault />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/user/password"}
                        element={
                            <MasterTemplate>
                                <UserPassword />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/admin"}
                        element={
                            <MasterTemplate>
                                <AdminDefault></AdminDefault>
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/admin/usersadmin"}
                        element={
                            <MasterTemplate>
                                <AdminUserWorkcentreRole />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/admin/rolefeature"}
                        element={
                            <MasterTemplate>
                                <AdminRoleFeature />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/admin/printerline"}
                        element={
                            <MasterTemplate>
                                <AdminPrinterLine />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/admin/sqldeploy"}
                        element={
                            <MasterTemplate>
                                <SqlDeploy />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/crew"}
                        element={
                            <MasterTemplate>
                                <CrewDefault />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/merck"}
                        element={
                            <MasterTemplate>
                                <MerckDefault />
                            </MasterTemplate>
                        }
                    />
                    <Route
                        path={"/test"}
                        element={
                            <MasterTemplate>
                                <TestPageDefault />
                            </MasterTemplate>
                        }
                    />
                </Routes>
            </React.Fragment>
        );
    }
}

export default App;
